import React from "react";
import { Box, Card, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

const StatusCard = ({ item }) => {
  return (
    <Card
      sx={{ p: 2.5, height: "100%", position: "relative", overflow: "hidden" }}
    >
      {/* soft tinted circle in the far corner */}
      <Box
        sx={{
          position: "absolute",
          width: 110,
          height: 110,
          borderRadius: "50%",
          bgcolor: alpha(item.tone, 0.06),
          right: -35,
          bottom: -45,
        }}
      />
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems={{ xs: "flex-start", sm: "center" }}
        sx={{ position: "relative" }}
      >
        <Box
          sx={{
            width: 52,
            height: 52,
            flexShrink: 0,
            borderRadius: "14px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 26,
            color: item.tone,
            bgcolor: alpha(item.tone, 0.12),
          }}
        >
          {item.icon}
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="body2" color="text.secondary" noWrap>
            {item.name}
          </Typography>
          <Stack direction="row" alignItems="baseline" spacing={0.75}>
            <Typography
              fontSize={26}
              fontWeight={800}
              color="#101828"
              lineHeight={1.3}
            >
              {item.value != null ? Number(item.value).toLocaleString() : "-"}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              fontWeight={600}
            >
              {item.unit}
            </Typography>
          </Stack>
        </Box>
      </Stack>
    </Card>
  );
};

export default StatusCard;
